import * as React from 'react';
import { classes, keyframes, style } from 'typestyle';
import { Blue } from '../../../styles/colors';
const Loader = ({ className, color = Blue } = {}) => {
    return (React.createElement("svg", { width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', className: classes('ta-loader-icon', loaderIconStyle, className) },
        React.createElement("path", { d: 'M12.2695 14.4237C11.5014 15.7038 8.28272 15.2284 8.39245 12.5217C8.47543 10.4748 10.4195 9.00944 12.7816 9.41272C17.2805 10.1808 18.9266 17.1383 13.314 19.9785C6.56124 23.3957 -1.15743 15.7854 2.33633 7.27257C4.74405 1.40596 13.7421 -1.04346 19.3901 4.18682', stroke: color, strokeWidth: '2.5', strokeLinecap: 'round' }),
        React.createElement("path", { d: 'M20.9394 6.93737L22.8534 4.10615C23.1296 3.6976 23.7678 3.89323 23.7676 4.38637L23.7649 11.2206C23.7648 11.6171 23.3253 11.8557 22.9928 11.6399L17.2594 7.92C16.8457 7.65159 17.0293 7.00977 17.5223 7.00064L20.9394 6.93737Z', fill: color, fillRule: 'evenodd', clipRule: 'evenodd' })));
};
const loaderAnimation = keyframes({
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(360deg)' },
});
const loaderIconStyle = style({
    animation: loaderAnimation,
    animationTimingFunction: 'linear',
    animationDuration: '1.4s',
    animationIterationCount: 'infinite',
});
export default Loader;
//# sourceMappingURL=Loader.js.map